//
// NavigationAction.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractAction";
import "./NavigationActionType";
import "./NavigationActionBehavior";
import "./ActionParameter";

var NavigationAction = createModule("BIRD::NavigationAction", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractAction"], EventDispatcher, [
    ,
    {
        mappings: 7,
        type: 4,
        behavior: 4,
        value: 7,
        navigationAction: 1,
        parameters: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default NavigationAction;
